/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BasicInfo } from './BasicInfo';
import {
    BasicInfoFromJSON,
    BasicInfoFromJSONTyped,
    BasicInfoToJSON,
} from './BasicInfo';
import type { Demographics } from './Demographics';
import {
    DemographicsFromJSON,
    DemographicsFromJSONTyped,
    DemographicsToJSON,
} from './Demographics';
import type { ReferralSource } from './ReferralSource';
import {
    ReferralSourceFromJSON,
    ReferralSourceFromJSONTyped,
    ReferralSourceToJSON,
} from './ReferralSource';

/**
 * 
 * @export
 * @interface HchbCreatePatientTaskBody
 */
export interface HchbCreatePatientTaskBody {
    /**
     * 
     * @type {any}
     * @memberof HchbCreatePatientTaskBody
     */
    service_line: any | null;
    /**
     * 
     * @type {BasicInfo}
     * @memberof HchbCreatePatientTaskBody
     */
    basic_info: BasicInfo;
    /**
     * 
     * @type {Demographics}
     * @memberof HchbCreatePatientTaskBody
     */
    demographics: Demographics;
    /**
     * 
     * @type {any}
     * @memberof HchbCreatePatientTaskBody
     */
    documents?: any | null;
    /**
     * 
     * @type {ReferralSource}
     * @memberof HchbCreatePatientTaskBody
     */
    referral: ReferralSource;
    /**
     * 
     * @type {any}
     * @memberof HchbCreatePatientTaskBody
     */
    payor_sources?: any | null;
    /**
     * 
     * @type {any}
     * @memberof HchbCreatePatientTaskBody
     */
    diagnoses: any | null;
    /**
     * 
     * @type {any}
     * @memberof HchbCreatePatientTaskBody
     */
    requested_date_of_evaluation: any | null;
    /**
     * 
     * @type {string}
     * @memberof HchbCreatePatientTaskBody
     */
    taskType: HchbCreatePatientTaskBodyTaskTypeEnum;
}


/**
 * @export
 */
export const HchbCreatePatientTaskBodyTaskTypeEnum = {
    CreatePatient: 'create_patient'
} as const;
export type HchbCreatePatientTaskBodyTaskTypeEnum = typeof HchbCreatePatientTaskBodyTaskTypeEnum[keyof typeof HchbCreatePatientTaskBodyTaskTypeEnum];


/**
 * Check if a given object implements the HchbCreatePatientTaskBody interface.
 */
export function instanceOfHchbCreatePatientTaskBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "service_line" in value;
    isInstance = isInstance && "basic_info" in value;
    isInstance = isInstance && "demographics" in value;
    isInstance = isInstance && "referral" in value;
    isInstance = isInstance && "diagnoses" in value;
    isInstance = isInstance && "requested_date_of_evaluation" in value;
    isInstance = isInstance && "taskType" in value;

    return isInstance;
}

export function HchbCreatePatientTaskBodyFromJSON(json: any): HchbCreatePatientTaskBody {
    return HchbCreatePatientTaskBodyFromJSONTyped(json, false);
}

export function HchbCreatePatientTaskBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbCreatePatientTaskBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'service_line': json['service_line'],
        'basic_info': BasicInfoFromJSON(json['basic_info']),
        'demographics': DemographicsFromJSON(json['demographics']),
        'documents': !exists(json, 'documents') ? undefined : json['documents'],
        'referral': ReferralSourceFromJSON(json['referral']),
        'payor_sources': !exists(json, 'payor_sources') ? undefined : json['payor_sources'],
        'diagnoses': json['diagnoses'],
        'requested_date_of_evaluation': json['requested_date_of_evaluation'],
        'taskType': json['taskType'],
    };
}

export function HchbCreatePatientTaskBodyToJSON(value?: HchbCreatePatientTaskBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'service_line': value.service_line,
        'basic_info': BasicInfoToJSON(value.basic_info),
        'demographics': DemographicsToJSON(value.demographics),
        'documents': value.documents,
        'referral': ReferralSourceToJSON(value.referral),
        'payor_sources': value.payor_sources,
        'diagnoses': value.diagnoses,
        'requested_date_of_evaluation': value.requested_date_of_evaluation,
        'taskType': value.taskType,
    };
}

